import request from '@/utils/request';
//预约活动详情
export function getActivityBookingQuery(values) {
  return request('/activityBooking/queryAnalyses', {
    method: 'POST',
    data: values,
  });
}
//门店列表
export function getStoreList(values) {
  return request('/activityBooking/queryAnalysesStore', {
    method: 'POST',
    data: values,
  });
}
//明细列表分页查询
export function getQueryAnalysesDetailPage(values) {
  return request('/activityBooking/queryAnalysesDetailPage', {
    method: 'POST',
    data: values,
  });
}

//预约活动分析核销明细查询
export function getQueryConsumeDetail(values) {
  return request('/activityBooking/queryConsumeDetail', {
    method: 'POST',
    data: values,
  });
}
// //暂停活动
// export function activityGroupPause(values) {
//   return request('/activityGroup/pause', {
//     method: 'POST',
//     data: values,
//   });
// }
